<template>
  <div style="position: relative; height: 90%">
    <img
      class="closeBtn"
      src="../../../../../../assets/close.png"
      @click="closeGrid"
    />

    <div class="flexout" style="margin-left: 15px">
      <span class="line"></span><span class="text">网格</span>
    </div>
    <div class="oneTitle">
      {{ gridList.length > 0 ? gridList[0].gridTypeName : "暂无数据" }}
    </div>
    <div style="display: inline">
      <div
        class="table-chart"
        style="margin-top: 10px; overflow: auto; height: 95%"
      >
        <div v-for="(item, key) in gridList" :key="key">
          <ul class="Info_box">
            <li class="Info_one" style="list-style: none">
              <div
                class="tab_box fangbgGreen"
                :style="{ 'background-color': ceColor[key] }"
              ></div>
              <div class="textOver fontBlue" style="">{{ item.name }}</div>
              <div class="textOver fontBlue" style="margin-top: 15px">
                负责人:{{ item.chargeName }}
              </div>
              <div class="textOver fontBlue" style="margin-top: 15px">
                联系电话：{{ item.chargePhone }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryGridFindOne } from "../../../apis/src/Query";
export default {
  data() {
    return {
      gridData: {},
      ceColor: [
        "#FF0000",
        "#008000",
        "#0000FF",
        "#FFA500",
        "#00FFFF",
        "#7FFFD4",
        "#F0FFFF",
        
        "#8A2BE2",
        "#A52A2A",
        "#DEB887",
        "#5F9EA0",
        "#7FFF00",
        "#D2691E",
        "#FF7F50",
        "#6495ED",
        "#FFF8DC",
        "#DC143C",
        "#00008B",
        "#008B8B",
        "#B8860B",
        "#006400",
        "#BDB76B",
        "#8B008B",
        "#556B2F",
        "#FF8C00",
        "#9932CC",
        "#8B0000",
        "#E9967A",
        "#8FBC8F",
        "#483D8B",
        "#F5F5DC",
      ],
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    gridList: {
      type: Array,
      default: [],
    },
  },
  // watch: {
  //   gridList: function (val) {
  //     console.log(val);
  //     if (val && val.length > 0) {
  //       const that = this;
  //       if (that.gridList.length > 0) {
  //         that.gridList = that.gridList.forEach((item, index) => {
  //           item.color = that.ceColor[index];
  //         });
  //       }
  //     }
  //   },
  // },
  created() {},
  mounted() {},
  methods: {
    closeGrid() {
      this.$emit("closegrid", false);
    },
    getGridInfo() {
      let that = this;
      queryGridFindOne({
        data: { id: this.id },
        success(res) {
          console.log("网格详情");
          console.log(res);
          that.gridData = res;
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flexout {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  .line {
    display: inline-block;
    width: 4px;
    height: 22px;
    background: #00c6ff;
    margin-right: 10px;
  }
  .text {
    font-size: 18px;
    line-height: 26px;
    color: #23c3ff;
  }
}
.tab_box {
  width: 12px;
  height: 12px;
  position: absolute;
  top: 18px;
  left: 22px;
}
.fangbgGreen {
  background-color: #10812f;
}
.fangbgBlue {
  background-color: #63bdc8;
}
.betw {
  justify-content: space-between;
}
.textStart {
  justify-content: flex-start;
}

.marginr15 {
  margin-right: 15px;
}
.icon2 {
  border: solid 1px #ffdc4e;
  color: #ffdc4e;
}
.icon3 {
  border: solid 1px #ff4e4e;
  color: #ff4e4e;
}
.colorText {
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #2ac1ff;
}
.martop15 {
  margin-top: 15px;
}
.Info_box {
  padding-left: 0px;
  .Info_one {
    list-style: none;
    margin-bottom: 10px;
    width: 100%;
    height: 121px;
    padding: 15px 42px;
    box-sizing: border-box;
    position: relative;
    background-image: linear-gradient(
      90deg,
      rgba(9, 36, 75, 0.4) 0%,
      rgba(17, 58, 116, 0.71) 26%,
      #174d9a 50%,
      rgba(24, 79, 157, 0.98) 52%,
      rgba(17, 58, 116, 0.69) 76%,
      rgba(9, 36, 75, 0.4) 100%
    );
    .topInfo {
      width: 100%;
      height: 23px;
      line-height: 23px;
    }
  }
}
.fontBlue {
  color: #2ac1ff !important;
  font-size: 14px;
}
.textOver {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fontWhite {
  color: #ffffff !important;
  opacity: 0.4;
}
.fontRed {
  color: #fe4e4e !important;
}
.fontYellow {
  color: #2bc2ff;
}
.closeBtn {
  width: 1.8rem;
  height: 1.8rem;
  position: absolute;
  top: 6px;
  right: 10px;
}

.oneTitle {
  // padding:0px 20px;
  height: 4rem;
  line-height: 4rem;
  margin-bottom: 5px;
  background-image: linear-gradient(
    0deg,
    rgba(11, 58, 119, 0.08) 0%,
    rgba(12, 55, 109, 0.34) 32%,
    #0c3364 64%,
    #0c2f59 100%
  );
  font-size: 1.4rem;
  font-weight: bold;
  color: #00c6ff;
  text-align: center;
}
</style>